import axios from '../helpers/api';

export default {
    async getCountriesAll() {        
    
        const res = await axios.get(
            `/api/geo/countries/all`,
        );
        return res.data;
    },
    
}